import { Button, Grid, Typography } from "@mui/material"
import React, { useState } from "react"
import LayoutPage from "src/components/page-layout/layout-page"
import theme from "src/utils/theme"
import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded'
import { useLocation } from "react-router-dom"
import AlertMessage from "src/components/alert-message"
import AccessService from "src/services/access-service"

const WithoutPermissionPage = () => {
    const [loading, setLoading] = useState(false)
    const [alertMessageState, setAlertMessageState] = React.useState({
        open: false,
        message: "",
        type: "info"
    })
    const location = useLocation()
    const accessService = new AccessService()
    const params = new URLSearchParams(location.search)


    const reportError = () => {
        setLoading(true)

        let erroFinal = params.get("erro")

        try {
            const parsed = JSON.parse(erroFinal)
            erroFinal =
                parsed?.response?.body?.detail ||
                parsed?.response?.data?.detail ||
                parsed?.body?.detail ||
                parsed?.message ||
                erroFinal
        } catch (e) {
            // Se não for um JSON válido, mantém o erro original
        }


        const errorData = {
            erro: erroFinal || "Acesso Negado",
            path: params.get("path") || "N/A",
            status: params.get("status") || "403",
            method: params.get("method") || "GET"
        }

        accessService.reportError(errorData).then(() => {
            setLoading(false)
            openAlert("Problema Reportado! Em breve entraremos em contato.", "success")
        }).catch(() => {
            setLoading(false)
            openAlert("Erro ao enviar reporte técnico.", "error")
        })
    }



    const requestTrial = () => {
        setLoading(true)
        let erroFinal = params.get("erro")

        try {
            const parsed = JSON.parse(erroFinal)
            erroFinal =
                parsed?.response?.body?.detail ||
                parsed?.response?.data?.detail ||
                parsed?.body?.detail ||
                parsed?.message ||
                erroFinal
        } catch (e) {
            // Se não for um JSON válido, mantém o erro original
        }


        const errorData = {
            erro: erroFinal || "Acesso Negado",
            path: params.get("path") || "N/A",
            status: params.get("status") || "403",
            method: params.get("method") || "GET"
        }

        accessService.requestTrial(errorData).then(() => {
            setLoading(false)
            openAlert("Solicitação Enviada Com Sucesso! Em breve entraremos em contato.", "success")
        })

    }

    const closeAlert = () => {
        setAlertMessageState({ ...alertMessageState, open: false })
    }

    const openAlert = (message, type) => {
        setAlertMessageState({
            ...alertMessageState,
            open: true,
            message: message,
            type: type
        })
    }

    return <LayoutPage title="C2P" loading={loading}>
        <AlertMessage open={alertMessageState.open} message={alertMessageState.message} type={alertMessageState.type} close={closeAlert} />
        <Grid container
            direction="column"
            justifyContent="center"
            alignItems="center"
            sx={{
                marginTop: 20
            }}
        >
            <Grid item sm={12} md={12} xl={12}>
                <SecurityRoundedIcon sx={{ fontSize: 120, color: theme.palette.gray.main }} />
            </Grid>
            <Grid item sm={12} md={12} xl={12}>
                <Typography sx={{
                    fontSize: '30px',
                    fontWeight: 'bold',
                    textAlign: "center",
                    color: theme.palette.primary.main,
                }}>
                    Você ainda não tem acesso a essa página.
                </Typography>
                <Typography sx={{
                    fontSize: '30px',
                    fontWeight: 'bold',
                    textAlign: "center",
                    color: theme.palette.primary.main,
                }}>
                    Solicite trial do serviço. Caso já tenha contratado reporte esse erro.
                </Typography>
            </Grid>
        </Grid>
        <br />
        <Grid container direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={1}>
            <Grid item >
                <Button variant="contained" onClick={reportError}>Reportar Erro</Button>
            </Grid>
            <Grid item >
                <Button variant="contained" onClick={requestTrial}>Solicitar Trial</Button>
            </Grid>
        </Grid>

    </LayoutPage>
}

export default WithoutPermissionPage